export default __webpack_public_path__ + "static/media/skullbug.41068994.jpg";